import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import CommonImage from '@components/CommonImage';
import { toastError, toastSuccess } from '@components/Toast';

import {
	MATERIAL_REQUISITION_PURPOSE,
	renderColorsColumn,
	renderFabricComposition,
	renderFabricType
} from '@features/material-requisition/utils';
import { useRemovePreliminaryItemsByIdMutation } from '@features/material-requisition/api/materialRequisitionApi';
import ViewRelatedInventory from '@features/material-requisition/components/ViewRelatedInventory';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { convertNumberToUSFormat } from '@utils/Util';

const NitexDevFabricTable = ({ materials = [], setIsShowMaterialForm, selectedRequisition }) => {
	const [removePreliminaryItemsById] = useRemovePreliminaryItemsByIdMutation();
	const dispatch = useDispatch();
	const [isShowRelatedInventory, setIsShowRelatedInventory] = useState(false);
	const [selectedInventoryMaterials, setSelectedInventoryMaterials] = useState([]);

	const handleRemove = async (material) => {
		try {
			dispatch(openLoader());
			await removePreliminaryItemsById(material.id).unwrap();
			toastSuccess('Removed successfully');
		} catch {
			toastError('Failed to remove');
		} finally {
			dispatch(closeLoader());
		}
	};

	const isShowAddBtn = () => {
		return ['REQUESTED', 'MATERIAL_ADDED'].includes(selectedRequisition.status);
	};

	const getInventoryBalance = (material) => {
		return material?.relatedInventoryAmount?.reduce((sum, item) => sum + (item?.balance || 0), 0) || 0;
	};

	return (
		<div className="material-requirement-table">
			<table className="table height-sm hover with-border">
				<thead>
					<tr>
						<th>Fabric Type</th>
						<th>Fabric details</th>
						<th>Requirement</th>
						{selectedRequisition.purpose !== MATERIAL_REQUISITION_PURPOSE[0].constant && (
							<th>Colors</th>
						)}
						<th>Related Inventory</th>
						<th>Total estimated price</th>
						<th>Action</th>
					</tr>
				</thead>
				<tbody>
					{materials?.map((material) => (
						<tr key={`material_${material?.id}`}>
							<td>{renderFabricType(material)}</td>
							<td>
								<p>{renderFabricComposition(material)}</p>
							</td>
							<td>
								{material?.quantity} {renderFabricType(material) === 'Knit' ? 'Kg' : 'Yard'}
							</td>
							{selectedRequisition.purpose !== MATERIAL_REQUISITION_PURPOSE[0].constant && (
								<td>{renderColorsColumn([{ ...material?.materialColorResponse }])}</td>
							)}
							<td>
								{material?.relatedInventoryAmount?.length > 0 ? (
									<span
										className="blue text-underline cursor-pointer"
										onClick={() => {
											setSelectedInventoryMaterials(material.relatedInventoryAmount);
											setIsShowRelatedInventory(true);
										}}
									>
										{material?.relatedInventoryAmount?.length} match&nbsp;
										{getInventoryBalance(material)}
										{renderFabricType(material) === 'Knit' ? ' Kg' : ' Yard'} found
									</span>
								) : (
									<span>-</span>
								)}
							</td>
							<td>{convertNumberToUSFormat(material?.cost)}</td>
							<td>
								{['MATERIAL_ADDED'].includes(selectedRequisition.status) && (
									<div className="action-icon cursor-pointer">
										<CommonImage
											src="/icons/delete_gray.svg"
											width={20}
											onClick={() => handleRemove(material)}
										/>
									</div>
								)}
							</td>
						</tr>
					))}
				</tbody>
			</table>
			{isShowAddBtn() && (
				<div className="text-right">
					<button className="button size32 mb-12" onClick={() => setIsShowMaterialForm(true)}>
						Add another material
					</button>
				</div>
			)}
			{isShowRelatedInventory && (
				<ViewRelatedInventory
					onCloseModal={() => {
						setIsShowRelatedInventory(false);
						setSelectedInventoryMaterials([]);
					}}
					materials={selectedInventoryMaterials}
				/>
			)}
		</div>
	);
};

export default NitexDevFabricTable;
